module.exports = __webpack_public_path__ + "img/appointmentActive.6e913c32.svg";